export default __webpack_public_path__ + "static/media/banner.3a42f845.png";